module.exports = __webpack_public_path__ + "static/acupun_1_md-0bc9ec0d132bc1dc2e3f22c5dc2b02bc.png";